import { createAction, props } from '@ngrx/store';
import { PayPeriodModel } from 'src/app/models/payPeriodModel';

export const loadPayPeriods = createAction('[PayPeriod] Load Pay Periods');
export const loadPayPeriodsSuccess = createAction('[PayPeriod] Load Pay Periods Success', props<{ periods: PayPeriodModel[] }>());

export const changePayPeriod = createAction('[PayPeriod] Change Pay Period', props<{ periodID: number }>());
